import config from '../../config';

export default function BugButton({ page, systemID }) {
  const mailTo = config.bugReporting.mailTo.join(';');
  const cc = config.bugReporting.cc.join(';');
  let subject = `NLD Refinement - Bug Report on ${page}`;
  if (systemID) {
    subject += ` (System ID: ${systemID})`;
  }
  return (
    <a className='navigation-button report-bug' href={`mailto:${mailTo}?cc=${cc}&subject=${subject}`}>
      Report Bug
    </a>
  );
}
